// extracted by mini-css-extract-plugin
module.exports = {"containerPin":"pin_containerPin__2wH6k"};